import { render } from "./ProductMatrix.vue?vue&type=template&id=713fe422&scoped=true"
import script from "./ProductMatrix.vue?vue&type=script&lang=js"
export * from "./ProductMatrix.vue?vue&type=script&lang=js"

import "./ProductMatrix.vue?vue&type=style&index=0&id=713fe422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713fe422"]])

export default __exports__